<template>
  <div class="tab-pane fade" id="intergrate-content" role="tabpanel" aria-labelledby="pills-genarel-tab">
    <form class="row g-3">
      <div class="col-md-6">
        <label class="form-label">活動</label><br>
        <select id="selectActivities" class="selectpicker" v-model.number="selectActivity" multiple>
            <option :value="selectAll">全部</option>
            <option v-for="(list, index) in activityList" :key="index" :value="list">{{ list.nameDate  }}</option>
          </select>
      </div>

      <div class="col-md-3">
        <label class="form-label">資料開始時間</label>
        <datetime input-class="form-control" type="date" format="yyyy-MM-dd"
          :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="0" :max-datetime="maxSelectTime" :auto="true"
          v-model="startTime">
        </datetime>
      </div>

      <div class="col-md-3">
        <label class="form-label">資料結束時間</label>
        <datetime input-class="form-control" type="date" format="yyyy-MM-dd"
          :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="0" :max-datetime="maxSelectTime" :auto="true"
          v-model="endTime">
        </datetime>
      </div>

      <div class="col-md-6 d-flex align-items-end">
        <div class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk">
          <i class="fas fa-search"></i> 查詢
        </div>
        <a href='javascript:;' class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="exportCSV">
          <i class="fas fa-share"></i> 匯出
        </a>
      </div>
    </form>

    <h1 style="margin-top: 0px;">綜合查詢</h1>

    <div class="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-flex g-2">
      <div class="col order-2 order-md-1">
        <div class="card card-clean h-100">
          <div class="bd-example">
            <table id="activity-intergrate" class=" w3-table-all table table-hover table-striped">
              <thead class="table-dark">
                <tr>
                  <th scope="col" >#</th>
                  <th scope="col">時間</th>
                  <th scope="col">活動</th>
                  <!-- <th scope="col">在園人數</th> -->
                  <th scope="col">進場人數</th>
                  <!-- <th scope="col">離場人數</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in dataTableList" :key="key" :class="tableCenterStyle">
                  <td>{{ key + 1 }}</td>
                  <td>{{ item.time }}</td>
                  <td>{{item.actvityName}}</td>
                  <!-- <td>{{item.peopleStay}}</td> -->
                  <td>{{item.peopleIn}}</td>
                  <!-- <td>{{item.peopleOut}}</td> -->
                </tr>
              </tbody>
            </table>


          </div>

        </div>
      </div>
      <div class="col order-1  order-md-2 pt-4">
        <div id="intergrate-chart" >
                    <apexchart
                      type="line"
                      height="200"
                      :options="chartSetting"
                      :series="activtyHourCountData"
                    ></apexchart>
                  </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import exportCSV from "../../utils/exportCSV";
import { getCountPerDay } from "../../api/elasticSearch/peopleApis";
import ApexchartObject from '../../utils/apexchartObject/searchActivity'

export default {
  name: "SearchActivity",
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      tableStyle: "w3-table-all table table-hover table-striped",
      tableThStyle: "table-dark",
      tableCenterStyle: "text-center",
      selectAll: CONST.MULTI_SELECT_ALL,
      table: null,
      startTime:  moment(moment().clone().startOf("month").format("YYYY-MM-DD hh:mm")).format(), //vue-datetime-24period,
      endTime:  moment(moment().clone().endOf("minute").format("YYYY-MM-DD hh:mm")).format(), //vue-datetime-24period
      dataTableList: [],

      activtyHourCountData:[],
      allActivity: [],
      selectActivity: [],
      chartSetting: {...ApexchartObject.intergateSearchOption},
      queryActivies: [],
      activityList:[],
    };
  },
  computed: {
    ...mapState("activity", { activityListData: "allActivitys" }),

    maxSelectTime() {
      return moment().startOf("h").toISOString();
    },
  },
  watch: {
    // selectActivity() {
    //   if(this.selectActivity[0] === CONST.MULTI_SELECT_ALL && this.selectActivity.length === 1) {
    //     $('#selectActivities').selectpicker('selectAll');
    //   }
    // },
    activityListData:{
      handler(newValue, oldValue){
        //按照 startDate 排序 newValue 的順序
        let sortList = [...newValue].sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
          sortList.forEach((item) => {
            item.nameDate = item.activityName + ` (${moment(item.startDate).format('YYYY.MM.DD')})`
          })

          this.activityList = sortList;

      }
    },

    selectActivity: {
     handler(newValue, oldValue){
       if(newValue[0] === CONST.MULTI_SELECT_ALL&& oldValue [0] !== CONST.MULTI_SELECT_ALL){
        //表示若已有選擇其他景區，再選擇全部的情況
         $('#selectActivities').selectpicker('selectAll');
       }
       
       if(newValue[0] !== CONST.MULTI_SELECT_ALL&& oldValue [0] === CONST.MULTI_SELECT_ALL){
         //表示取消全部選擇的情況
         
         $('#selectActivities').selectpicker('deselectAll');
         this.selectActivity = [];
        }
        if(oldValue[0] === CONST.MULTI_SELECT_ALL && newValue.length < oldValue.length ){
          // console.log("從選擇全部中移除部分景區")
          //表示選擇全部，但是未全選
          
          //表示從全選狀態離開，產生非全選的狀態，移除陣列this.selectScenicAreas的[0](selectAll)
          this.selectActivity.shift();
        }}
    }
  },
  methods: {
    async exportCSV() {
      this.selectActivity.length > 0 ? this.getQueryActivityBySelect() : await this.getQueryActivityByTime();
      const list = await this.searchElkByActivity()
      if(Utils.isEmptyObject(list)) {
        return
      }

      // const csvContent = [['時間', '活動' ,'在園人數', '進場人數', '離場人數',]]
      const csvContent = [['時間', '活動' , '進場人數',]]
      list.forEach(item => {
        const row = []
        row.push(item.time)
        row.push(item.actvityName)
        // row.push(item.peopleStay)
        row.push(item.peopleIn) 
        // row.push(item.peopleOut) 
        csvContent.push(row)
      })
      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}_活動綜合查詢.csv`
      exportCSV.genCSVFile(csvContent, fileName)
    },

    async queryElk() {
      console.log('this.selectActivity', this.selectActivity)
      this.selectActivity.length > 0 ? this.getQueryActivityBySelect() : await this.getQueryActivityByTime();
      this.dataTableList = await this.searchElkByActivity()
      this.setChartData(this.dataTableList)
      this.updateTable();
    },

    async getQueryActivityByTime() {
      this.queryActivies = await this.searchActivities(); // 找尋時間內的所有活動
    },

    getQueryActivityBySelect() {
      if(this.selectActivity[0] === CONST.MULTI_SELECT_ALL) {
        this.queryActivies = this.activityList
      } else {
        this.queryActivies = this.selectActivity
      }
    },

    async searchElkByActivity() {
      let dataList = []

      const total = {
        peopleIn: 0,
        peopleOut: 0,
        peopleStay: 0,
        time: '統計',
        actvityName: ''
      }
      for (let i = this.queryActivies.length - 1; i >= 0; i--) 

      {
        const acticity = this.queryActivies[i] //活動只有一天
        const data = await this.searchElk(acticity.startDate, acticity.endDate)

        // console.log('data', data)
        data.forEach(d => {
          d.actvityName = acticity.activityName
          dataList.push(d)

          total.peopleIn = total.peopleIn + d.peopleIn
          total.peopleOut = total.peopleOut + d.peopleOut
          total.peopleStay = total.peopleStay + d.peopleStay
        })
        
      }

      dataList.push(total)
      return dataList
    },

    async searchElk(startTime, endTime) {

      //活動查詢時間範圍以活動起訖時間計算區間，若非起訖時間內的資料，前端以 0 顯示
      // const st = moment(startTime).startOf('d').valueOf()
      // const et = moment(endTime).endOf('d').valueOf()
      const st = moment(startTime).valueOf() // 
      const et = moment(endTime).valueOf()

      
      const condition1 = {
        streamingIds: [this.cctvPeopleIn[0].streamId],
        startTime: st,
        endTime: et,
        interval: "1d",
        objectTypes: [],
        dataType: "",
      };

      const condition2 = {
        streamingIds: [this.cctvPeopleOut[0].streamId],
        startTime: st,
        endTime: et,
        interval: "1d",
        objectTypes: [],
        dataType: "",
      };

      const result1In = await getCountPerDay(
        Object.assign({ message: "(in)" }, condition1)
      ); //入口進入
      const result1Out = await getCountPerDay(
        Object.assign({ message: "(out)" }, condition1)
      ); //入口出去

      const result2In = await getCountPerDay(
        Object.assign({ message: "(in)" }, condition2)
      ); //出口出去
      const result2Out = await getCountPerDay(
        Object.assign({ message: "(out)" }, condition2)
      ); //出口進入

      const days = moment(et).add(1, 'd').diff(moment(st), "d"); // 查詢範圍間隔
      
      const timestamps =  Array.from({ length: days }).map((v, i) =>
        moment(st).startOf('day')
          .add(i, "d")
          .valueOf()
      );

      
      const entranceInCount = timestamps.map((t) => {
        return result1In[t] ? result1In[t] : 0;
      });
      const entranceOutCount = timestamps.map((t) => {
        return result1Out[t] ? result1Out[t] : 0;
      });

      const exitInCount = timestamps.map((t) => {
        return result2In[t] ? result2In[t] : 0;
      });
      const exitOutCount = timestamps.map((t) => {
        return result2Out[t] ? result2Out[t] : 0;
      });


      let dataList = timestamps.map((t, index) => {
        // console.log("this.getYearTime(t)",this.getYearTime(t))

          const data = {
            time: this.getTime(t),
            actvityName: this.getActivityName(t),
            peopleStay: 0,
            peopleIn: entranceInCount[index] + exitOutCount[index],
            peopleOut: entranceOutCount[index] + exitInCount[index]
          }
          data.peopleStay = (data.peopleIn - data.peopleOut < 0) ? 0 : data.peopleIn - data.peopleOut

          return data;
        });

      return dataList;
    },

    setChartData(dataList) {
      const list = dataList.slice(0, -1); //移除最後一個統計元素，產生新陣列

      //重新排序由遠至近
      list.sort((a, b) => {
        return  new Date(a.time)  -  new Date(b.time);
      })

      this.activtyHourCountData = []
      // const peopleStayCount = list.map((d, i) => {
      //   return d.peopleStay
      // })

      const peopleInCount = list.map((d, i) => {
        return d.peopleIn
      })

      // const peopleOutCount = list.map((d, i) => {
      //   return d.peopleOut
      // })
      // this.activtyHourCountData.push({name: '在園人數', data: peopleStayCount})
      this.activtyHourCountData.push({name: '進場人數', data: peopleInCount})
      // this.activtyHourCountData.push({name: '離場人數', data: peopleOutCount})   
      

      let chartSetting = {...this.chartSetting}
      const xaxisCategories = list.map((d, i) => {
        // return `${moment(d.time).format('MM/DD')}`
        return d.time ? d.time : '-'
      })

      let a = list.map((d, i) => {
        // return `${moment(d.time).format('MM/DD')}`
        return d.actvityName
 
      })
      chartSetting.tooltip.x.formatter =  function (val,{ series, seriesIndex, dataPointIndex }) {
        // console.log("seriesIndex",seriesIndex)
          return a[dataPointIndex]
      }
      // console.log("this.activtyHourCountData",this.activtyHourCountData);
      // console.log('xaxisCategories', xaxisCategories);
      chartSetting = {...chartSetting, ...{xaxis:{categories: xaxisCategories}}} //https://github.com/apexcharts/vue-apexcharts/issues/74#issuecomment-472717678
      this.chartSetting = {...chartSetting} // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
    },

    async searchActivities() {
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
      };
      return await this.$store.dispatch("activity/getActivities", condition);
    },

    getActivityName (t) {
      const activity = this.activityList.find(a => moment(t).isBetween(a.startDate, a.endDate))
      return Utils.isEmptyObject(activity)? '-' : activity.activityName
    },

    getTime: function (t) {
      if (Utils.isEmptyObject(t)) {
        return "-";
      }

      const time = moment(t)
      return `${time.format('YYYY/MM/DD')}`
    },

    getYearTime: function (t) {
      if (Utils.isEmptyObject(t)) {
        return "-";
      }
      const time = moment(t)
      return `${time.format('YYYY')}`
    },

    initTable: function () {
      this.table = $("#activity-intergrate").DataTable({
        autoWidth: false, 
        columnDefs: [
        // { targets: 0, width: '8%' },  
        // { targets: 1, width: '22%' },
        // { targets: 2, width: '25%' },
        // { targets: 3, width: '15%' },

        { targets: 0, width: '15%' }, 
        { targets: 3, width: '50%' }  
        ],
        // aoColumns: [
        //   ...new Array($("#activity-intergrate th").length - 1),
        //   {
        //     // bSortable: false,
        //   },
        // ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 32
      });

      
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
  },
  async mounted() {
    this.updateTable();

    await this.$store.dispatch("activity/getAllActivity");
    $('#selectActivities').selectpicker({
        noneSelectedText: '請選擇'
    })    

    this.cctvPeopleIn =
      this.$store.getters["videoCamera/getCCTVById"]("cv99001");
    this.cctvPeopleOut =
      this.$store.getters["videoCamera/getCCTVById"]("cv99002");

    if (
      Utils.isEmptyObject(this.cctvPeopleIn) ||
      Utils.isEmptyObject(this.cctvPeopleOut)
    ) {
      // 此頁重整重新呼叫api
      await this.$store.dispatch("videoCamera/getCCTV");
      this.cctvPeopleIn =
        this.$store.getters["videoCamera/getCCTVById"]("cv99001");
      this.cctvPeopleOut =
        this.$store.getters["videoCamera/getCCTVById"]("cv99002");
    }

  },
};
</script>
<style>
.apexcharts-menu-item{
  padding: 6px 7px;
  font-size: 14px;
  cursor: pointer; 
  text-align: center;
}
tbody > tr > td {width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
/* 
thead > tr > th:nth-child(1) {
 width:30px !important;
} */

</style>